export const projects = [
    {
        title: '(Pet) Marvel Information Portal',
        description: 'Information portal about Marvel characters and comics.',
        gitHubLink: 'https://github.com/AKarpenka/marvel',
        demoLink: 'https://marvel-info-sk.vercel.app',
        image: '/images/projects/marvel_pet.png'
    },
    {
        title: '(Pet) Holiday Tick List',
        description: 'The classic implementation of the ToDo list , which includes most of the techniques and functionality that is used in real projects: authentication, CRUD requests.',
        gitHubLink: 'https://github.com/AKarpenka/to-do-application',
        demoLink: '',
        image: '/images/projects/ToDoApp_pet.jpg'
    },
    {
        title: '(Pet) Watermarks On Photos',
        description: 'Pure JS. The app to upload up to 9 photos and add a watermark to them.',
        gitHubLink: 'https://github.com/AKarpenka/adding-watermarks-js',
        demoLink: 'https://adding-watermarks.vercel.app',
        image: '/images/projects/watermarks_pet.jpg'
    },
    {
        title: '(Pet) Employee Accounting App',
        description: 'A pure React application that implements adding employees, changing their data and deleting them, as well as filtering and searching.',
        gitHubLink: 'https://github.com/AKarpenka/EmployeeAccounting',
        demoLink: 'https://employee-accounting-gilt.vercel.app',
        image: '/images/projects/employee_pet.png'
    }
];